<aslib-title Text="Liquidação Pagamento" SubText=" " Icon="fa fas fa-tasks"></aslib-title>

<div class="card-block">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item active"><a class="nav-link active" routerLinkActive="active"
      [routerLink]="['liq_empenho']"><strong>Geração da Liquidação</strong></a></li>
    
      <li class="nav-item"><a class="nav-link" routerLinkActive="active" 
      [routerLink]="['liq']"><strong>Resumo da Liquidação</strong></a></li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade show active" role="tabpanel">
      <router-outlet></router-outlet>
    </div>
  </div>
  
</div>
<br>


// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-pagamento.component.html